<template>
  <router-view />
</template>

<style>
@import url("assets/styles.css");
</style>
